"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskItem = exports.TaskItemDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_node_1 = require("./content-node");
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
var icon_1 = require("../elements/icon");
var badge_1 = require("../elements/badge");
var ellipsis_button_1 = require("../elements/ellipsis-button");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_modal_1 = require("../../hooks/use-modal");
var current_user_can_1 = require("../../utils/current-user-can");
var entity_form_route_1 = require("./entity-form-route");
exports.TaskItemDefaultProps = {
  showDetails: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style-type: none;\n    color: ", ";\n    padding: 0;\n    font-weight: 400;\n    margin: 0;\n    display: flex;\n    align-items: flex-start;\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    list-style-type: none;\n    color: ", ";\n    padding: 0;\n    font-weight: 400;\n    margin: 0;\n    display: flex;\n    align-items: flex-start;\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])), theme_1.theme.COLOR('dark'))
});
var BulletStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: 2px solid ", ";\n    background: ", ";\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "], ["\n    border: 2px solid ", ";\n    background: ", ";\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), function (_a) {
    var isComplete = _a.isComplete;
    return isComplete && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: ", ";\n      border-color: ", ";\n    "], ["\n      background: ", ";\n      border-color: ", ";\n    "])), theme_1.theme.COLOR('green'), theme_1.theme.COLOR('green'));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: 1px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    margin-top: 1px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "])))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    ", "\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    ", "\n  "])), function (_a) {
    var isComplete = _a.isComplete;
    return isComplete && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      // text-decoration: line-through;\n      color: ", ";\n    "], ["\n      // text-decoration: line-through;\n      color: ", ";\n    "])), theme_1.theme.COLOR('green'));
  })
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-size: ", "em;\n  "], ["\n    margin-top: ", ";\n    font-size: ", "em;\n  "])), theme_1.theme.UNIT(2), 14 / 15)
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-left: ", ";\n    position: relative;\n    line-height: 18px;\n    top: -2px;\n  "], ["\n    margin-left: ", ";\n    position: relative;\n    line-height: 18px;\n    top: -2px;\n  "])), theme_1.theme.UNIT(2))
});
var EllipsisButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-left: ", ";\n    margin-top: -2px;\n    visibility: visible;\n  "], ["\n    margin-left: ", ";\n    margin-top: -2px;\n    visibility: visible;\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.li(templateObject_12 || (templateObject_12 = __makeTemplateObject([""], [""]))),
  Bullet: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BulletStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Body: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Header: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Name: styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  EditButton: (0, styled_components_1.default)(ellipsis_button_1.EllipsisButton)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), EllipsisButtonStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
My.Container = styled_components_1.default.li(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ContainerStyles);
var TaskItem = function (props) {
  var className = props.className,
    entity = props.entity,
    showDetails = props.showDetails;
  var name = entity.name,
    description = entity.description,
    due = entity.due,
    completed = entity.completed;
  var icons = (0, use_icons_1.useIcons)();
  var Tick = icons.Tick;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var modal = (0, use_modal_1.useModal)();
  var onEditClick = function () {
    modal.show(react_1.default.createElement(entity_form_route_1.EntityUpdateFormRoute, {
      isModal: true,
      onSubmit: function (entity) {
        modal.hide();
      },
      onCancel: function () {
        return modal.hide();
      },
      id: entity.id,
      definition: defn
    }));
  };
  var hasDescription = showDetails && description && !!description.text;
  var hasDueDate = !!due;
  var isComplete = !!completed;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Bullet, {
    isComplete: isComplete
  }, isComplete && react_1.default.createElement(My.Icon, {
    size: 12,
    color: "light"
  }, react_1.default.createElement(Tick, null))), react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Header, {
    _hasBorder: showDetails
  }, react_1.default.createElement(My.Name, {
    isComplete: isComplete
  }, name, isComplete && react_1.default.createElement(My.Badge, {
    color: "green"
  }, t('Completed'))), (0, current_user_can_1.currentUserCanUpdate)(defn.name) && react_1.default.createElement(My.EditButton, {
    dotSize: 6,
    space: 0.75,
    title: "Edit Task",
    onClick: onEditClick
  })), hasDescription && react_1.default.createElement(My.Description, {
    entity: description
  })));
};
exports.TaskItem = TaskItem;
exports.TaskItem.defaultProps = exports.TaskItemDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;